










import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class Properties extends Vue {
	name = "account-properties";

	get address() {
		//ToDo
		return "";
		// return this.$store.state.account.address;
	}
	get pin() {
		//ToDo
		return "";
		//return this.$store.state.account.pin;
	}
	get lastChecked() {
		//ToDo
		return "";
		//return this.$store.state.account.lastChecked;
	}
}
